export enum ReadingPaneViewType {
    Pane = 'Pane',
    Modal = 'Modal',
    DeeplinkPopOut = 'DeeplinkPopOut',
    ProjectionPopOut = 'ProjectionPopOut',
}
